import PropTypes from 'prop-types';
// @mui
import { Checkbox, Typography, Stack } from '@mui/material';

// ----------------------------------------------------------------------

TableSelectedActions.propTypes = {
  dense: PropTypes.bool,
  actions: PropTypes.node,
  rowCount: PropTypes.number,
  numSelected: PropTypes.number,
  onSelectAllRows: PropTypes.func,
};

export default function TableSelectedActions({ dense, actions, rowCount, numSelected, onSelectAllRows }) {
  return (
    <div className="inline">
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          pr: 2,
          pl: '26px',
          top: 0,
          left: 0,
          zIndex: 99,
          height: 58,
          borderRadius: 1,
          position: 'sticky',
          width: '100%',
          bgcolor: 'primary.lighter',
          ...(dense && {
            pl: 1,
            height: 38,
          }),
        }}
      >
        <Checkbox
          indeterminate={numSelected > 0 && numSelected < rowCount}
          checked={rowCount > 0 && numSelected === rowCount}
          onChange={(event) => onSelectAllRows(event.target.checked)}
        />

        <Typography
          variant="subtitle1"
          sx={{
            ml: 2,
            flexGrow: 1,
            color: 'primary.main',
            ...(dense && {
              ml: 3,
            }),
          }}
        >
          تعداد آیتم های انتخاب شده : {numSelected}
        </Typography>

        {actions && actions}
      </Stack>
    </div>
  );
}
